var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag mr-3"},[_c('b-icon',{staticClass:"mr-1 is-size-9",attrs:{"icon":"circle","type":_vm.$options.messages.statusClass[this.status]}}),_vm._v(" "+_vm._s(_vm.$options.messages.status[this.status])+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }